<template>
  <div>
    <v-container class="ml-10">
      <p class="display-1 mt-7">정품 인증 설정</p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 인증 서비스에 사용되는 설정을 할 수 있습니다.
      </p>
      <p class="mb-0 subtitle-1 font-weight-light">
        정품 보증관련 설정과 쇼핑몰 정품 인증 항목 추가 및 회원등급 변경, 쿠폰/적립금 혜택 설정이 가능합니다.
      </p>

      <v-tabs class="mt-10 col-12 ml-0 mr-10 pl-0">
        <!--
          정품 인증 설정
        -->
        <v-tab class="title">정품 인증 설정</v-tab>
        <v-tab-item class="pl-0">
          <WarrantyPeriodSetting ref="WarrantyPeriodSetting"></WarrantyPeriodSetting>
        </v-tab-item>

        <!--
          회원 정품 인증 항목 추가
        -->
        <v-tab class="title">회원 정품 인증 항목 추가</v-tab>
        <v-tab-item>
          <MemberAuthAddItem ref="MemberAuthAddItem"></MemberAuthAddItem>
        </v-tab-item>

        <!--
          인증 혜택 설정
        -->
        <v-tab class="title">인증 혜택 설정</v-tab>
        <v-tab-item>
          <WarrantyBenefitSetting ref="WarrantyBenefitSetting"></WarrantyBenefitSetting>
        </v-tab-item>

        <!--
          코드 미인증 상품 설정
        -->
        <v-tab class="title" v-if="is_as_custom">코드 미인증 상품 설정</v-tab>
        <v-tab-item v-if="is_as_custom">
          <CodeUnauthProductSetting ref="CodeUnauthProductSetting"></CodeUnauthProductSetting>
        </v-tab-item>
      </v-tabs>
    </v-container>
  </div>
</template>

<script>
import WarrantyPeriodSetting from "@/components/authservice/warranty_period/WarrantyPeriodSetting.vue";
import MemberAuthAddItem from "@/components/authservice/warranty_period/MemberAuthAddItem.vue";
import WarrantyBenefitSetting from "@/components/authservice/warranty_period/WarrantyBenefitSetting.vue";
import CodeUnauthProductSetting from "@/components/authservice/warranty_period/CodeUnauthProductSetting.vue";
import M from "@/libs/mapping.js";

export default {
  components: {
    WarrantyPeriodSetting,
    MemberAuthAddItem,
    WarrantyBenefitSetting,
    CodeUnauthProductSetting,
  },
  data() {
    return {
      is_as_custom: false,
    };
  },
  created() {
    this.is_as_custom = M.isCustomCheck() === "as_custom";
  },
};
</script>
